import { Group, Layout, Page, Tree } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useResource, useStore, useTheme, useToast, useTree } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { APIS, SF_MENU_MGMT_SRCH, URLS } from "@/tra/tancis/ptli/ptl/menu/services/PtliMenuService";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const PTLI1001001Q = (): JSX.Element => {
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0061"],
    });
    const modal = useModal();
    const toast = useToast();
    const tree = useTree();
    const { theme } = useTheme();
    const navigate = useNavigate();
    const { setStore, getStore } = useStore({ pgeUid: pgeUid });

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0052" },
        ],
    });

    const form = {
        menuMgmtSrch: useForm({ defaultSchema: SF_MENU_MGMT_SRCH }),
    };

    const fetch = {
        getMenuList: useFetch({
            api: (data: any) => APIS.getMenuList(data),
            onSuccess: (data) => {
                const menuList = data["menuList"].content;
                tree.setData([
                    {
                        name: "ROOT",
                        menuId: "menu_root",
                        menuPath: "ROOT",
                        children: handler.createTreeData(menuList, [], 1, "menu_root"),
                    },
                ]);

                tree.openTree();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // 조회가 실패하였습니다.
        }),
    };

    const handler = {
        createTreeData: (orgList: any, newList: any, level: any, menuId: any) => {
            const tempList = orgList
                .map((item: any) => {
                    return {
                        name: comnUtils.replaceEmpty(item.menuNm),
                        checkbox: false,
                        menuId: comnUtils.replaceEmpty(item.menuId),
                        menuNm: comnUtils.replaceEmpty(item.menuNm),
                        menuLvl: comnUtils.replaceEmpty(item.menuLvl, 0),
                        menuOrd: comnUtils.replaceEmpty(item.menuOrd, 0),
                        uprMenuId: comnUtils.replaceEmpty(item.uprMenuId),
                        uprMenuNm: comnUtils.replaceEmpty(item.uprMenuNm),
                        menuPath: comnUtils.replaceEmpty(item.menuPath),
                    };
                })
                .filter((item: any) => item["menuLvl"] === level && item["uprMenuId"] === menuId);

            if (tempList.length === 0) return newList;

            tempList.forEach((item: any) => {
                if (!item.children) item.children = [];
                handler.createTreeData(orgList, item.children, item["menuLvl"] + 1, item["menuId"]);
                newList.push(item);
            });

            return newList;
        },
        onTreeClick: (treeInfo: any) => {
            form.menuMgmtSrch.setValue("menuId", treeInfo.menuId);
            form.menuMgmtSrch.setValue("menuPath", treeInfo.menuPath);
        },
        onMenuNewBtnClick: () => {
            const formMenuId = form.menuMgmtSrch.getValue("menuId"); // Target Upper Menu ID
            const url = URLS.ptli1001002s;
            const trgtUrl = comnUtils.isEmpty(formMenuId) ? url : `${url}/${formMenuId}`;
            navigate(`${trgtUrl}`);
        },
        onEditBtnClick: () => {
            const formMenuId = form.menuMgmtSrch.getValue("menuId");
            if (formMenuId === "ROOT") {
                modal.openModal({ content: "msg.ptl.00693" }); // You cannot modify the Root menu. !== Root 메뉴는 수정할 수 없습니다. ==!
                return;
            }

            if (comnUtils.isEmpty(formMenuId)) {
                modal.openModal({ content: "msg.ptl.00686" }); // Please select the menu. !== 메뉴를 선택하세요. ==!
                return;
            }

            navigate(`${URLS.ptli1001003s}/${formMenuId}`);
        },
        onSearchBtnClick: () => {
            form.menuMgmtSrch.setValue("menuId", "");
            form.menuMgmtSrch.setValue("menuPath", "");

            setStore(pgeUid, form.menuMgmtSrch.getValues());

            form.menuMgmtSrch.handleSubmit(
                () => {
                    fetch.getMenuList.fetch(form.menuMgmtSrch.getValues());
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // 데이터가 유효하지 않습니다.
                },
            )();
        },
        onClear: () => {
            form.menuMgmtSrch.clearValues();
            tree.setData([]);
        },
    };

    useEffect(() => {
        const store = getStore(pgeUid);
        if (!comnUtils.isEmpty(store)) {
            form.menuMgmtSrch.setValue("bsopClsfCd", store.bsopClsfCd);
            form.menuMgmtSrch.setValue("ptlTpCd", store.ptlTpCd);
        }

        if (
            comnUtils.isEmpty(form.menuMgmtSrch.getValue("bsopClsfCd")) ||
            comnUtils.isEmpty(form.menuMgmtSrch.getValue("ptlTpCd"))
        ) {
            return;
        }

        handler.onSearchBtnClick();
    }, [theme.lang]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.menuMgmtSrch.schema.bsopClsfCd} />
                            <Group.Control {...form.menuMgmtSrch.schema.ptlTpCd} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Layout.Button role={"reset"} onClick={() => handler.onClear()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Layout.Button role={"search"} onClick={() => handler.onSearchBtnClick()} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Header>
                    <Group.Title title={"T_MENU_LIST"} />
                </Group.Header>
                <Group.Body>
                    <Tree {...tree.tree} size={12} height={300} onClick={handler.onTreeClick} />
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.menuMgmtSrch.schema.menuPath} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"new"} onClick={handler.onMenuNewBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"edit"} onClick={handler.onEditBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
